import { ref } from 'vue';

const showScroll = ref(false);
let timer: ReturnType<typeof setTimeout> | undefined;

function handleMouseEnter() {
  timer = setTimeout(() => {
    showScroll.value = true;
  }, 500);
}

function handleMouseLeave() {
  clearTimeout(timer);
  showScroll.value = false;
}

export {handleMouseEnter , handleMouseLeave ,showScroll}